import React from 'react';
import ProductCard from '../ProductCard';

const img = (key, fallback) =>
  (window.foxQuoteFormImages && window.foxQuoteFormImages[key]) || fallback;

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

const ProductSelectionStep = ({ onSelect, selectedProduct }) => {
  const products = [
    {
      id: 'windows',
      title: 'Windows',
      image: img('product_selection_windows', `${BASE_URL}/windows.png`),
    },
    {
      id: 'internal-products',
      title: 'Internal Doors and Windows',
      image: img('product_selection_internal_products', `${BASE_URL}/AluminiumDoors.png`),
    },
    {
      id: 'front-back-doors',
      title: 'Front & Back Doors',
      image: img('product_selection_front_back_doors', 'https://foxwindowsanddoors.com/app/uploads/2024/03/Spitfire-Front-Doors.jpg'),
    },
    {
      id: 'bifolding-sliding-french-doors',
      title: 'Bifolding, Sliding and French Doors',
      image: img('product_selection_bifolding_sliding_french_doors', `${BASE_URL}/Bifolding.jpg`),
    },
    {
      id: 'conservatories',
      title: 'Conservatories & Extensions',
      image: img('product_selection_conservatories', `${BASE_URL}/Conservatories & Extensions.png`),
    },
    {
      id: 'conservatory-roofs',
      title: 'Conservatory Roofs',
      image: img('product_selection_conservatory_roofs', `${BASE_URL}/Conservatory Roofs.png`),
    },
    {
      id: 'verandas-pergolas',
      title: 'Verandas & Pergolas',
      image: img('product_selection_verandas_pergolas', `${BASE_URL}/Verandas.png`),
    },
  ];

  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Select Your Product
      </h2>

      {/* Product Grid */}
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 px-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            image={product.image}
            title={product.title}
            isSelected={selectedProduct === product.id}
            onClick={() => onSelect(product.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductSelectionStep;
